export const BROWSE_USER_SETTINGS_KEY = 'internal.browse-users-allowed';
